/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalObservacoesDadosPessoaisAliases {
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FORM_0 = 'form-0',
  PANEL_MODAL_OBSERVACOES_DADOS_PESSOAIS = 'panel-modal-observacoes-dados-pessoais',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { ModalObservacoesDadosPessoaisAliases };
